var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useEffect, useState } from 'react';
import store from 'store';
import 'dayjs/locale/fr-ca';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { useTranslation } from 'react-i18next';
import { Badge, ListItemIcon, ListItemText, MenuItem, } from '@material-ui/core';
import { NewReleases } from '@material-ui/icons';
import dayjs from 'dayjs';
import { CentralProviderContext } from '../../../centralProviderContext/CentralProviderContext';
import { useGoogleAnalytics } from '../../../hooks/useGoogleAnalytics';
import { ReleaseNotesDialog } from './ReleaseNotesDialog';
import { processReleaseNotesList } from './utils';
export function WhatsNew(props) {
    dayjs.extend(localizedFormat);
    var t = useTranslation().t;
    var googleAnalyticsUtils = useGoogleAnalytics();
    var releaseNotes = props.releaseNotes;
    var _a = __read(useState(false), 2), showDialog = _a[0], setShowDialog = _a[1];
    var _b = __read(useState(), 2), sortedReleaseNotes = _b[0], setSortedReleaseNotes = _b[1];
    var _c = useContext(CentralProviderContext), application = _c.application, centralProfile = _c.centralProfile, currentLanguage = _c.currentLanguage;
    var storeKey = "release_notes_".concat(application, "_").concat(centralProfile.uid, "_").concat(currentLanguage);
    var lastRead = store.get(storeKey);
    useEffect(function () {
        // Sort notes by release date
        var sorted = processReleaseNotesList(releaseNotes, centralProfile);
        if (sorted)
            setSortedReleaseNotes(sorted);
    }, [releaseNotes]);
    if (!(sortedReleaseNotes === null || sortedReleaseNotes === void 0 ? void 0 : sortedReleaseNotes.length))
        return null;
    var mostRecentRelease = sortedReleaseNotes[0];
    var pendingReading = !lastRead || dayjs(lastRead).isBefore(mostRecentRelease.releaseDate);
    var handleClick = function () {
        setShowDialog(true);
        if (googleAnalyticsUtils)
            googleAnalyticsUtils.event();
        store.set(storeKey, mostRecentRelease.releaseDate);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MenuItem, { onClick: handleClick },
            React.createElement(ListItemIcon, { style: { minWidth: '33px' } },
                React.createElement(Badge, { invisible: !pendingReading, color: "error", variant: "dot" },
                    React.createElement(NewReleases, { color: "primary" }))),
            React.createElement(ListItemText, { primary: t("What's New!") })),
        React.createElement(ReleaseNotesDialog, { releaseNotes: releaseNotes, open: showDialog, setOpen: function (open) { setShowDialog(open); } })));
}
//# sourceMappingURL=WhatsNew.js.map